import {Toast} from 'vant'
import * as Reg from './reglist'

export const urlPrefix = {
    0:'',
    1:'api',//api[线上环境时需要加 'api'，本地环境不需要加填''即可]
    2:'api/xzgzh',//单独的配置开奖信息服务前缀
    3:'api/xzxzs',//单独的配置语音小助手功能需求的服务前缀
}
export const configAli ={
    region: '你的OSS区域',//你的OSS区域 // 例如 'oss-cn-hangzhou'
    accessKeyId: '你的AccessKeyId',//你的AccessKeyId
    accessKeySecret: '你的AccessKeySecret',//你的AccessKeySecret
    bucket: '你的Bucket名称',//你的Bucket名称
}

// 西藏福彩公众号的
// APPID	wx8d13ccae778de142
// AppSecret	9ff4ccd5751f850bbf02e8187a9782b1

// 畅享互联官方公众号的
// APPID    wxfaa642c75a57e1f8
// App_secret: 90d55ca93e038a37a8a8a76027474453

// 西藏福彩发布公众号的
// APPID    wxf1cd2e4050f1c7a7
// AppSecret	43630ac868835609aae6aaa895b0f49bec

//中彩嘉胜公众号的
// appid    wxbba2080c75bf62c0
// AppSecret    217d1dfe1351972e87576f2466893959

/**
 * 将中文大写转成数字
 * @params num
 */
export function toNumChines(num) {
    let newNum = "";
    let getWan = (num) => {
        if(num==='一'){
            newNum = 1;
        }else if(num==='二'){
            newNum = 2;
        }else if(num==='三'){
            newNum = 3;
        }else if(num==='四'){
            newNum = 4;
        }else if(num==='五'){
            newNum = 5;
        }else if(num==='六'){
            newNum = 6;
        }else if(num==='七'){
            newNum = 7;
        }else if(num==='八'){
            newNum = 8;
        }else if(num==='九'){
            newNum = 9;
        }else if(num==='十'){
            newNum = 10;
        }
        return newNum;
    }
    return getWan(num);
}


/**
 * 通过身份证信息计算出生年月日
 */
export const getBirthByDate = (idCard)=>{
    const year = idCard.substr(6, 4); // 身份证年
    const month = idCard.substr(10, 2); // 身份证月
    const date = idCard.substr(12, 2); // 身份证日
    return `${year}-${month}-${date}`;
}
/**
 * 通过出生日期计算年龄
 */
export const getDateByAge = (strBirthday)=>{
    let returnAge,
        strBirthdayArr=strBirthday.split("-"),
        birthYear = strBirthdayArr[0],
        birthMonth = strBirthdayArr[1],
        birthDay = strBirthdayArr[2],
        d = new Date(),
        nowYear = d.getFullYear(),
        nowMonth = d.getMonth() + 1,
        nowDay = d.getDate();
    if(nowYear === birthYear){
        returnAge = 0;//同年 则为0周岁
    }
    else{
        let ageDiff = nowYear - birthYear ; //年之差
        if(ageDiff > 0){
            if(nowMonth === birthMonth) {
                let dayDiff = nowDay - birthDay;//日之差
                if(dayDiff < 0) {
                    returnAge = ageDiff - 1;
                }else {
                    returnAge = ageDiff;
                }
            }else {
                let monthDiff = nowMonth - birthMonth;//月之差
                if(monthDiff < 0) {
                    returnAge = ageDiff - 1;
                }
                else {
                    returnAge = ageDiff ;
                }
            }
        }else {
            returnAge = -1;//返回-1 表示出生日期输入错误 晚于今天
        }
    }
    return returnAge;//返回周岁年龄
}

export const validateInput=(input)=> {
    // 正则表达式：不允许字母和汉字，允许数字、符号等
    const regex = /^[^a-zA-Z\u4e00-\u9fa5]*$/;
    return regex.test(input);
}

/*
 * 校验表单字段
 * 方法blurRule、IdentityCodeValid结合使用
 * idCard：身份证校验
 * name：中文名称校验
 * phone：手机号校验
 * email：邮箱校验
 * address：详细地址校验
 * postcode：邮编校验
 * ratio、weight、height：数字校验
 */
export const blurRule=(value, rule)=> {
    //开户支行，只支持中文文字，不包括符号、英文、数字
    if(rule.name === "bankName"){
        if(!value){
            Toast('开户支行不能为空');
            return false
        }else if (!Reg.chineseCharacter.test(value)) {
            Toast('仅允许输入中文，不包含符号和英文以及数字等');
            return false
        }
    }else if (rule.name === "idCard") {
        if(Reg.chinaStr.test(value)){
            Toast('证件号码不包括中文');
            return false
        }else if(![15,18].includes(value.length)){
            Toast('身份证号长度必须为15位或18位')
            return false
        }else if(value.length=== 15){
            Toast('身份证号长度为15位时，只能录入数字')
            return false
        }else if(value.length=== 18
            && !Reg.allNum.test(value.substr(0,17))
            && (value.substr(17,1)!=='X' || !Reg.allNum.test(value.substr(17,1)))){
            Toast('身份证号长度为18位时，前17位只能录入数字，第18位允许数字或“X”')
            return false
        }else if (!IdentityCodeValid(value)) {
            Toast('请输入正确的证件号码')
            return false
        }else if(getDateByAge(getBirthByDate(value))<18){
            Toast('年龄未满十八岁！');
            return false;
        }
    }else if (rule.name === "name") {
        let noDot = value.replace('·','')
        if(!value){
            Toast('姓名不能为空')
            return false
        }else if(noDot.length<2){
            Toast('姓名至少包含2个中文汉字')
            return false
        }else if(value.length>12){
            Toast('姓名最长为12个长度')
            return false
        }else if (!Reg.nameReg.test(value)) {
            Toast('姓名只允许输入中文或中文·中文格式')
            return false
        }
    }else if (rule.name === "phone") {
        if(!value){
            Toast("手机号码不能为空");
            return false
        }else if(value.length<11){
            Toast("手机号码长度必须为11位纯数字格式");
            return false
        }else if (value.substr(0,1)!=='1'){
            Toast("手机号码第一位固定为1");
            return false
        }else if (!Reg.phoneRegs.test(value)) {
            Toast("请输入正确的手机号码");
            return false
        }
    }else if(rule.name === 'address'){
        if(!value){
            Toast('详细地址不能为空')
            return false
        }else if (Reg.addressregEn.test(value)||Reg.addressregCn.test(value)) {
            Toast("请输入正确的详细地址");
            return false
        }
    }else if(rule.name === 'email'){
        if (!Reg.mailReg.test(value)) {
            Toast("请输入正确的邮箱号码");
            return false
        }
    }else if(rule.name === 'postcode'){
        let reg = /^[1-9]\d{6}/;
        if (!reg.test(value)) {
            Toast("请输入正确的邮编地址");
            return false
        }
    }else if (rule.name === 'ratio'){
        if (!value) {
            Toast('输入不可以为空');
            return false
        }
        setTimeout(() => {
            if (!Number(value)) {
                Toast('请输入正整数');
                return false
            } else {
                const re = /^[0-9]*[1-9][0-9]*$/;
                const rsCheck = re.test(value);
                if (!rsCheck) {
                    Toast('请输入正整数');
                    return false
                } else {

                }
            }
        }, 0);
    }else if (rule.name === "weight" || rule.name === "height") {
        if (!Reg.weight_height.test(value)) {
            Toast("请输入数字");
            return false
        }
    }
    return true
}
/*
 * 身份证校验
 */
export const IdentityCodeValid = (code)=> {
    let city={11:"北京",12:"天津",13:"河北",14:"山西",15:"内蒙古",21:"辽宁",22:"吉林",23:"黑龙江 ",31:"上海",32:"江苏",33:"浙江",34:"安徽",35:"福建",36:"江西",37:"山东",41:"河南",42:"湖北 ",43:"湖南",44:"广东",45:"广西",46:"海南",50:"重庆",51:"四川",52:"贵州",53:"云南",54:"西藏 ",61:"陕西",62:"甘肃",63:"青海",64:"宁夏",65:"新疆",71:"台湾",81:"香港",82:"澳门",91:"国外 "};
    let pass= true;
    if(!code || !/^\d{6}(18|19|20)?\d{2}(0[1-9]|1[012])(0[1-9]|[12]\d|3[01])\d{3}(\d|X)$/i.test(code)){
        pass = false;
    }else if(!city[code.substr(0,2)]){
        pass = false;
    }else{
        //18位身份证需要验证最后一位校验位
        if(code.length == 18){
            code = code.split('');
            //∑(ai×Wi)(mod 11)
            //加权因子
            let factor = [ 7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2 ];
            //校验位
            let parity = [ 1, 0, 'X', 9, 8, 7, 6, 5, 4, 3, 2 ];
            let sum = 0;
            let ai = 0;
            let wi = 0;
            for (let i = 0; i < 17; i++)
            {
                ai = code[i];
                wi = factor[i];
                sum += ai * wi;
            }
            let last = parity[sum % 11];
            if(parity[sum % 11] != code[17]){
                pass =false;
            }
        }
    }
    return pass;
}
























/**填写详细地址不允许出险标点符号
 * 限制标点符号，正则验证
 * @param value
 */
export function isSpecialTxt(value) {
    let regEn = /[`~!@#$%^&*()_+<>?:"{},.\/;'[\]]/im;
    let regCn = /[·！#￥（——）：；“”‘、，|《。》？、【】[\]]/im;
    return !(regEn.test(value) || regCn.test(value));
}



/**
 * 判断时间范围
 */
export function time_range(){
    let date = new Date();
    if (date.getHours() >= 6 && date.getHours() < 12) {
        return false;
    } else return (date.getHours() >= 12) && (date.getHours() < 23);
}
/**
 * 判断时间范围
 * @param beginTime //开始时间
 * @param endTime //结束时间
 */
export function date_time_range(beginTime, endTime) {
    let strBing = beginTime.split(":");
    if (strBing.length !== 2) {
        return false;
    }
    let strEnd = endTime.split(":");
    if (strEnd.length !== 2) {
        return false;
    }
    let b = new Date();
    let e = new Date();
    let n = new Date();
    b.setHours(strBing[0]);
    b.setMinutes(strBing[1]);
    e.setHours(strEnd[0]);
    e.setMinutes(strEnd[1]);
    return n.getTime() - b.getTime() > 0 && n.getTime() - e.getTime() < 0;
}

/**
 * 手机号码正则验证
 * @param value
 */
export function isPhone(value) {
    let reg = /^1[0-9]{10}$/;
    return reg.test(value);
}
/**
 * html5本地sessionStorage储存封装
 * @param key
 * @param value
 */
export const setSessionItem = function(key, value) {
    if (typeof(value)!='string') {
        value = JSON.stringify(value);
    }
    return window.sessionStorage.setItem(key, value);
}
/**
 * html5本地sessionStorage储存获取封装
 * @param key
 */
export const getSessionItem = function(key) {
    let string = window.sessionStorage.getItem(key);
    try {
        let obj=JSON.parse(string);
        if(typeof obj == 'object' && obj ){
            return obj;
        }else{
            if(string==='null') {
                return null;
            } else {
                return string;
            }
        }
    } catch(e) {
        if(string==='null') {
            return null;
        } else {
            return string;
        }
    }
}
/**
 * html5本地sessionStorage删除储存
 * @param key
 */
export const delSessionItem = function(key) {
    window.sessionStorage.removeItem(key);
}
/**
 * html5本地localStorage储存封装
 * @param key
 * @param value
 */
export const setLocalItem = function(key, value) {
    if (typeof(value)!='string') {
        value = JSON.stringify(value);
    }
    return window.localStorage.setItem(key, value);
}
/**
 * html5本地localStorage储存获取封装
 * @param key
 */
export const getLocalItem = function(key) {
    let string = window.localStorage.getItem(key);
    try {
        let obj=JSON.parse(string);
        if(typeof obj == 'object' && obj ){
            return obj;
        }else{
            if(string==='null') {
                return null;
            } else {
                return string;
            }
        }
    } catch(e) {
        if(string==='null') {
            return null;
        } else {
            return string;
        }
    }
}
/**
 * html5本地localStorage删除储存
 * @param key
 */
export function delLocalItem(key) {
    localStorage.removeItem(key);
}


/**
 * 时间戳转换年月日格式
 * 与filter.js的formatDate和formatDates方法配合使用过滤时间格式
 */
export const formatDate=(date, fmt)=> {
    if (/(y+)/.test(fmt)) {
        fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length))
    }
    let o = {
        'M+': date.getMonth() + 1,
        'd+': date.getDate(),
        'h+': date.getHours(),
        'm+': date.getMinutes(),
        's+': date.getSeconds()
    }
    for (let k in o) {
        if (new RegExp(`(${k})`).test(fmt)) {
            let str = o[k] + ''
            fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? str : padLeftZero(str))
        }
    }
    return fmt
}
export const padLeftZero=(str)=> {
    return ('00' + str).substr(str.length)
}





/**银行卡校验
 * 位数正则验证
 * @param value
 */
export function CheckBankNo(value) {
    let bankno = value;
    if(bankno === "") {
        Toast('请填写银行卡号')
        return false;
    }
    if(bankno.length < 16 || bankno.length > 19) {
        Toast('银行卡号长度必须在16到19之间')
        return false;
    }
    let num = /^\d*$/; //全数字
    if(!num.exec(bankno)) {
        Toast('银行卡号必须全为数字')
        return false;
    }
    //开头2位
    // var strBin = "10,18,30,35,37,40,41,42,43,44,45,46,47,48,49,50,51,52,53,54,55,56,58,60,62,65,68,69,84,87,88,94,95,98,99";//全补银行开头数组合
    // var strBin = "42,43,52,55,62";
    //建设银行卡号前开头6位
    let strBin = '5453242,5491031,5544033,622725,622728,621284,421349,434061,434062,436728,436742,453242,491031,524094,526410,53242,53243,544033,552245,589970,620060,621080,621081,621466,621467,621488,621499,621598,621621,621700,622700,622707,622966,622988,625955,625956,553242,621082,623251,621673,623211,623668,623094,623669,436742,622280,356896,356899,356895,436718,436738,436745,436748,489592,531693,532450,532458,544887,552801,557080,558895,559051,622166,622168,622708,625964,625965,625966,628266,628366,625362,625363,628316,628317,622381,622675,622676,622677,622382,621487,621083,624329,621084,623350,624412,620107,623644,628448,624458,621534,623656'
    if(strBin.indexOf(bankno.substring(0, 6)) == -1) {
        Toast('银行卡号开头6位不符合规范')
        return false;
    }
    //Luhm校验
    if(!luhnCheck(bankno)){
        Toast("请检查银行卡号是否正确");
        return false;
    }else{
        return true;
    }
}








/**银行卡校验
 * 位数正则验证
 * @param bankno
 */
export function luhnCheck(bankno) {
    let lastNum = bankno.substr(bankno.length - 1, 1); //取出最后一位（与luhn进行比较）
    let first15Num = bankno.substr(0, bankno.length - 1); //前15或18位
    let newArr = new Array();
    for (let i = first15Num.length - 1; i > -1; i--) { //前15或18位倒序存进数组
        newArr.push(first15Num.substr(i, 1));
    }
    let arrJiShu = new Array(); //奇数位*2的积 <9
    let arrJiShu2 = new Array(); //奇数位*2的积 >9
    let arrOuShu = new Array(); //偶数位数组
    for (let j = 0; j < newArr.length; j++) {
        if ((j + 1) % 2 === 1) { //奇数位
            if (parseInt(newArr[j]) * 2 < 9) arrJiShu.push(parseInt(newArr[j]) * 2);
            else arrJiShu2.push(parseInt(newArr[j]) * 2);
        } else //偶数位
            arrOuShu.push(newArr[j]);
    }
    let jishu_child1 = new Array(); //奇数位*2 >9 的分割之后的数组个位数
    let jishu_child2 = new Array(); //奇数位*2 >9 的分割之后的数组十位数
    for (let h = 0; h < arrJiShu2.length; h++) {
        jishu_child1.push(parseInt(arrJiShu2[h]) % 10);
        jishu_child2.push(parseInt(arrJiShu2[h]) / 10);
    }
    let sumJiShu = 0; //奇数位*2 < 9 的数组之和
    let sumOuShu = 0; //偶数位数组之和
    let sumJiShuChild1 = 0; //奇数位*2 >9 的分割之后的数组个位数之和
    let sumJiShuChild2 = 0; //奇数位*2 >9 的分割之后的数组十位数之和
    let sumTotal = 0;
    for (let m = 0; m < arrJiShu.length; m++) {
        sumJiShu = sumJiShu + parseInt(arrJiShu[m]);
    }
    for (let n = 0; n < arrOuShu.length; n++) {
        sumOuShu = sumOuShu + parseInt(arrOuShu[n]);
    }
    for (let p = 0; p < jishu_child1.length; p++) {
        sumJiShuChild1 = sumJiShuChild1 + parseInt(jishu_child1[p]);
        sumJiShuChild2 = sumJiShuChild2 + parseInt(jishu_child2[p]);
    }
    //计算总和
    sumTotal = parseInt(sumJiShu) + parseInt(sumOuShu) + parseInt(sumJiShuChild1) + parseInt(sumJiShuChild2);
    //计算luhn值
    let k = parseInt(sumTotal) % 10 === 0 ? 10 : parseInt(sumTotal) % 10;
    let luhn = 10 - k;
    if (lastNum == luhn) {
        return true;
    } else {
        return false;
    }
}
export function getTime (time) {
    let date = new Date(time)
    let y = date.getFullYear()
    let m = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1)
    let d = (date.getDate() < 10 ? '0' + (date.getDate()) : date.getDate())
    return y + '年' + m + '月' + d + '日';
}
export function filterEmptyParams(params) {
    const result = {}

    Object.keys(params).forEach(key => {
        const value = params[key]

        // 过滤条件：不为空字符串、不为0、不是null、不是undefined
        if (value !== '' &&
            value !== 0 &&
            value !== null &&
            value !== undefined) {

            // 如果是数组，检查是否为空数组
            if (Array.isArray(value)) {
                if (value.length > 0) {
                    result[key] = value
                }
            } else {
                result[key] = value
            }
        }
    })

    return result
}
// 格式化文件大小
export function formatFileSize(bytes) {
    if (bytes === 0) return '0 Bytes';
    const k = 1024;
    const sizes = ['Bytes', 'KB', 'MB', 'GB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
}